Aquí tienes el código completo con la nueva sección de **Padrinos** agregada exactamente debajo de los Padres.

He organizado cada categoría de padrinos de forma elegante y limpia, agregando todos los elementos a la lógica de **GSAP** para que sus animaciones entren de manera consecutiva y fluida después de que aparezcan los padres.

```vue
<template>
  <div ref="bienvenidaRef" class="bienvenida-section">

    <div ref="encabezadoRef" class="encabezado-container">
      <p class="encabezado-fecha">05 de Septiembre <br>Houston, Texas.</p><br>
      <h2 class="encabezado-nombres">
        <span class="nombre-principal">Nidia </span><br>
        <span class="apellidos-novios">Rocha </span><br>
        <div class="separador-central">
          <div class="ampersand">&</div>
        </div>
        <span class="nombre-principal">Anselmo</span><br>
        <span class="apellidos-novios">Flores</span>
      </h2>
    </div>

    <div class="bienvenida-container">
      <p ref="textoPrincipalRef" class="bienvenida-text">{{ mensaje }}</p>

      <p ref="versiculoRef" class="versiculo"></p>

      <p ref="nosCasamosRef" class="textmia">{{ mensajeFinal }}</p>

      <div ref="padresContainerRef" class="padres-container">

        <p ref="bendicionRef" class="bienvenida-text bendicion-text">
          Con la Bendición de Dios y en compañía de
        </p>

        <h3 class="padres-titulo" ref="padresTituloRef"><br /> NUESTROS PADRES</h3>

        <p
          v-for="(padre, i) in listaPadres"
          :key="'padre-' + i"
          class="padres-nombre"
          :ref="el => { if (el) padresRefs[i] = el }"
          v-html="padre"
        >
        </p>

      </div>

      <div ref="padrinosContainerRef" class="padrinos-container">
        
        <h3 class="padres-titulo" ref="padrinosTituloRef"><br /> NUESTROS PADRINOS</h3>

        <div 
          v-for="(padrino, idx) in listaPadrinos" 
          :key="'padrino-' + idx"
          class="padrino-bloque"
          :ref="el => { if (el) padrinosRefs[idx] = el }"
        >
          <span class="padrino-categoria">{{ padrino.categoria }}</span>
          <p class="padrinos-nombre">{{ padrino.nombres }}</p>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'BienvenidaPage',
  setup() {

    const bienvenidaRef = ref(null)
    const encabezadoRef = ref(null)
    const textoPrincipalRef = ref(null)
    const versiculoRef = ref(null)
    const nosCasamosRef = ref(null)
    const padresTituloRef = ref(null)
    const padresContainerRef = ref(null)
    const bendicionRef = ref(null)
    const padresRefs = ref([])

    // Refs para Padrinos
    const padrinosContainerRef = ref(null)
    const padrinosTituloRef = ref(null)
    const padrinosRefs = ref([])

    const mensaje = ref('')
    const mensajeFinal = ref('')

    const listaPadres = [
      'Sergio Humberto Rocha',
      'María Teresa Rocha <i class="fa-solid fa-cross cruz-fa">',
      '&',
      'Andrés Flores',
      'Guillermina Martínez </i>'
    ]

    const listaPadrinos = [
      { categoria: 'Iglesia', nombres: 'Cristina y Lauro Garza' },
      { categoria: 'Anillos', nombres: 'Kimberly y Víctor Berrios' },
      { categoria: 'Lazo', nombres: 'Blanca y Manuel Anguiano' },
      { categoria: 'Arras', nombres: 'Maribel y Carlos García' },
      { categoria: 'Libro y Rosario', nombres: 'Rosa Nilda Flores' }
    ]

    const text = `Nuestras almas ya se habían encontrado, ahora deseamos bendecirlas ante la presencia de Dios, con la promesa de amarnos cada día-.

Por eso sería un honor que nos acompañaran en este día tan especial.`

    const textFinal = '¡Nos Casamos!'

    onMounted(async () => {
      await nextTick()

      // 🔹 ESTADO INICIAL (Ocultando también los elementos de Padrinos)
      gsap.set([
        encabezadoRef.value,
        textoPrincipalRef.value,
        versiculoRef.value,
        nosCasamosRef.value,
        bendicionRef.value,
        padresTituloRef.value,
        ...padresRefs.value,
        padrinosTituloRef.value,
        ...padrinosRefs.value
      ], { opacity: 0, y: 40 })

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({
            defaults: { ease: 'power2.out', duration: 1 }
          })

          tl.to(encabezadoRef.value, { opacity: 1, y: 0 })

            .add(() => { mensaje.value = text })
            .to(textoPrincipalRef.value, { opacity: 1, y: 0 }, '>-0.5')

            .to(versiculoRef.value, { opacity: 1, y: 0 }, '>-0.4')

            .add(() => { mensajeFinal.value = textFinal })
            .to(nosCasamosRef.value, { opacity: 1, y: 0 }, '>-0.4')

            .to(bendicionRef.value, { opacity: 1, y: 0 }, '>-0.4')

            .to(padresTituloRef.value, { opacity: 1, y: 0 }, '>-0.3')

            .to(padresRefs.value, {
              opacity: 1,
              y: 0,
              stagger: 0.25
            }, '>-0.2')

            // ✨ ANIMACIÓN CONSECUTIVA PARA PADRINOS (Entra justo después de los padres)
            .to(padrinosTituloRef.value, { opacity: 1, y: 0 }, '>-0.1')

            .to(padrinosRefs.value, {
              opacity: 1,
              y: 0,
              stagger: 0.25
            }, '>-0.2')

          obs.unobserve(entry.target)
        })
      }, { threshold: 0.2 }) // Umbral ajustado para dar espacio a la altura extra de la sección

      observer.observe(bienvenidaRef.value)
    })

    return {
      bienvenidaRef,
      encabezadoRef,
      textoPrincipalRef,
      versiculoRef,
      nosCasamosRef,
      padresTituloRef,
      padresContainerRef,
      bendicionRef,
      padresRefs,
      padrinosContainerRef,
      padrinosTituloRef,
      padrinosRefs,
      mensaje,
      mensajeFinal,
      listaPadres,
      listaPadrinos
    }
  }
}
</script>

<style scoped>
.versiculo {
  align-self: flex-end;
  margin-right: 10px;
  margin-top: -10px;
  font-family: 'padres', serif;
  font-size: 13px;
  color: #666;
  font-style: italic;
  opacity: 0;
}

.small-cross {
  font-size: 0.8em;
  color: #a17e4e;
  margin-left: 4px;
}

.bienvenida-section {
  padding: 30px 0;
  background-image: url('@/assets/7.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.encabezado-container {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
  opacity: 0;
  transform: translateY(50px);
}

.encabezado-fecha {
  font-family: 'Karla', sans-serif;
  font-size: 14px;
  color: #555;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.encabezado-nombres {
  font-family: 'Playfair Display', serif;
  font-size: 32px;
  font-weight: bold;
  color: #1e1e1e;
  line-height: 1.2;
}

.nombre-principal {
  font-family: 'nombres';
  font-weight: 400;
}

.bienvenida-container {
  text-align: center;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bienvenida-text {
  font-size: 18px;
  font-family: 'padres';
  color: #333;
  margin: 20px;
  transform: translateY(20px);
  opacity: 0;
  white-space: pre-line;
}

.bendicion-text {
  margin-top: 10px;
  margin-bottom: 10px;
}

.textmia {
  font-family: "say2";
  font-size: 26px;
  color: #302f2d;
  margin-top: 20px;
  opacity: 0;
}

.padres-container, .padrinos-container {
  margin-top: 20px;
  text-align: center;
}

.separador-central {
  text-align: center;
  margin: 10px 0;
}

.padres-titulo {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  font-weight: 500;
  color: #1e1e1e;
  line-height: 1.5;
  margin-bottom: 20px;
  letter-spacing: 1px;
}

.apellidos-novios {
  font-size: 30px;
  font-family: "Hearth Stone", sans-serif;
  font-weight: 400;
  line-height: 1.5;
  color: #878686;
  letter-spacing: 3px;
}

.padres-nombre {
font-family: 'Playfair Display', serif;  font-size: 19px;
  color: #444;
  margin-bottom: 8px;
  opacity: 0;
}

.ampersand {
  font-size: 30px;
  line-height: 0.8;
  color: rgb(93, 89, 89);
  opacity: 0.25;
  margin-top: 18px;
  margin-bottom: 18px;
  font-family: 'padres', serif;
}

/* ✨ ESTILOS EXCLUSIVOS PARA PADRINOS */
.padrino-bloque {
  margin-bottom: 14px;
  opacity: 0;
}

.padrino-categoria {
font-family: 'Playfair Display', serif;  font-size: 16px;
  color: #a17e4e;       /* Color café dorado */
  letter-spacing: 1.5px;
  text-transform: uppercase;
  display: block;
  margin-bottom: 2px;
}

.padrinos-nombre {
font-family: 'Playfair Display', serif;  font-size: 16px;
  color: #444;
  margin: 0;
}

/* ✨ ESTILO DE FONT AWESOME EN COLOR CAFÉ DORADO */
::v-deep .cruz-fa {
  color: #a17e4e;
  font-size: 13px;
  margin-left: 6px;
  vertical-align: middle;
}
</style>

```